import { render, staticRenderFns } from "./ThreeSelectSchools.vue?vue&type=template&id=43124d1b&scoped=true"
import script from "./ThreeSelectSchools.vue?vue&type=script&lang=js"
export * from "./ThreeSelectSchools.vue?vue&type=script&lang=js"
import style0 from "./ThreeSelectSchools.vue?vue&type=style&index=0&id=43124d1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43124d1b",
  null
  
)

export default component.exports